import { render, staticRenderFns } from "./noPhone.vue?vue&type=template&id=55f3023b&scoped=true&"
import script from "./noPhone.vue?vue&type=script&lang=js&"
export * from "./noPhone.vue?vue&type=script&lang=js&"
import style0 from "./noPhone.vue?vue&type=style&index=0&id=55f3023b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f3023b",
  null
  
)

export default component.exports